import { defineMessages } from 'react-intl';

export default defineMessages({
    stepZero: {
        id: 'loanAmountStep',
        defaultMessage: 'Loan amount'
    },
    businessIntroduction: {
        id: 'businessDetailsStep',
        defaultMessage: 'Business details'
    },
    personalInformation: {
        id: 'personalDetailsStep',
        defaultMessage: 'Personal details'
    },
    checkEligibility: {
        id: 'checkEligibility',
        defaultMessage: 'Check Eligibility'
    },
    businessAccounts: {
        id: 'tradingHistoryStep',
        defaultMessage: 'Complete application'
    },
    instantDecision: {
        id: 'instantDecisionStep',
        defaultMessage: 'Instant decision'
    },
    rlsEligibility: {
        id: 'rlsEligibilityStep',
        defaultMessage: 'Regulatory questions'
    },
    productOffers: {
        id: 'productOffersStep',
        defaultMessage: 'Your offers'
    }
});
